import _ from 'lodash';

export default {
  methods: {
    formatLastMessage(messages) {
      if (messages && messages.length) {
        const filteredMessages = _.orderBy(messages
          .filter(message => message && message.type === 'message'), ['created_at', 'id'], ['asc', 'asc']);
        const lastMessage = filteredMessages[filteredMessages.length - 1];
        if (lastMessage) {
          let lastMessageFormatted = '';
          if (lastMessage.origin) {
            lastMessageFormatted = 'Tu: ';
          }
          if (lastMessage.type === 'media') {
            const text = JSON.parse(lastMessage.text);
            lastMessageFormatted += text.caption ? text.caption : 'Archivo';
          } else if (lastMessage.text.includes('<span class="image-caption">')) {
            lastMessageFormatted += this.removeHtmlTags(lastMessage.text);
          } else if (lastMessage.text.includes('<audio controls')) {
            lastMessageFormatted += 'Audio';
          } else {
            lastMessageFormatted += this.removeHtmlTags(this.removeImgTags(lastMessage.text));
          }
          return lastMessageFormatted;
        }
      }
      return '';
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/formatLastMessage.js